module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-1920-b1e3507cf6a67230c397b55a527e2311.jpg";